<div class="flex flex-col items-center p-5 text-center">
  <div class="flex justify-between w-full mb-5">
    <h2 class="text-primary-dark font-bold text-xl">Alteração de Senha</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon class="small-icon text-primary-gray">close</mat-icon>
    </button>
  </div>
  <div class="w-full">
    <form [formGroup]="alterarSenhaForm">
      <div class="mb-4 text-left">
        <label for="senhaAtual" class="input-label">
          Senha Atual
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('senhaAtual')?.invalid && !senhaAtualFocused && alterarSenhaForm.get('senhaAtual')?.touched, 'input-field-focus': !(alterarSenhaForm.get('senhaAtual')?.invalid && !senhaAtualFocused && alterarSenhaForm.get('senhaAtual')?.touched)}">
          <input id="senhaAtual" [type]="passwordVisible ? 'text' : 'password'" formControlName="senhaAtual"
            placeholder="Insira sua senha atual" class="input-element py-3" (focus)="senhaAtualFocused = true"
            (blur)="senhaAtualFocused = false" />
          <button type="button" class="button-standard button-color-primary" (mousedown)="$event.preventDefault();"
            (click)="this.passwordVisible = !this.passwordVisible" class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">{{ passwordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
          </button>
        </div>
        <div
          *ngIf="alterarSenhaForm.get('senhaAtual')?.invalid && !senhaAtualFocused && alterarSenhaForm.get('senhaAtual')?.touched"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="alterarSenhaForm.get('senhaAtual')?.errors?.['required']">
            Senha atual é obrigatória.
          </div>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="novaSenha" class="input-label">
          Nova senha
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value, 'input-field-focus': !(alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value)}">
          <input id="novaSenha" [type]="newpasswordVisible ? 'text' : 'password'" formControlName="novaSenha"
            placeholder="Insira sua nova senha" class="input-element py-3" (focus)="novaSenhaFocused = true"
            (blur)="novaSenhaFocused = false" />
          <button type="button" class="button-standard button-color-primary" (mousedown)="$event.preventDefault();"
            (click)="this.newpasswordVisible = !this.newpasswordVisible" class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">{{ newpasswordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
          </button>
        </div>
        <div
          *ngIf="alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['required']">
            Senha é obrigatória.
          </div>
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['minlength']">
            Senha deve ter pelo menos 8 caracteres.
          </div>
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['pattern']">
            Senha deve conter letras maiúsculas, minúsculas e caracteres especiais.
          </div>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="confirmeSenha" class="input-label">
          Confirme a nova senha
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value, 'input-field-focus': !(alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value)}">
          <input id="confirmeSenha" [type]="confirmationPasswordVisible ? 'text' : 'password'"
            formControlName="confirmeSenha" placeholder="Repita a nova senha" class="input-element py-3"
            (focus)="confirmeSenhaFocused = true" (blur)="confirmeSenhaFocused = false" />
          <button type="button" class="button-standard button-color-primary"
            (click)="this.confirmationPasswordVisible = !this.confirmationPasswordVisible"
            class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">
              {{ confirmationPasswordVisible ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </div>
        <div
          *ngIf="alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="alterarSenhaForm.get('confirmeSenha')?.errors?.['required']">
            Confirmação de senha é obrigatória.
          </div>
          <div *ngIf="alterarSenhaForm.get('confirmeSenha')?.errors?.['mismatch']">
            As senhas não coincidem.
          </div>
        </div>
      </div>
      <button type="submit" class="button-standard button-color-primary"
        [ngClass]="{'button-disabled': alterarSenhaForm.invalid}" [disabled]="alterarSenhaForm.invalid"
        (click)="onSubmit()">
        Alterar Senha
      </button>
    </form>
  </div>
</div>